import React from 'react';
import { FarmSectionHeader } from './FarmSectionHeader';
import { StatCardGlow } from './StatCardGlow';
import { ActionCard } from './ActionCard';

import {
  Globe2,
  Users,
  Layers,
  Coins,
  Wallet,
  Factory,
  ShoppingCart,
  Network,
  LineChart,
} from 'lucide-react';

import { Activity, ArrowRightCircle } from 'react-feather';

export const PlatformAdminDashboard = ({ stats }) => {
  return (
    <div className="space-y-12">
      {/* HEADER */}
      <FarmSectionHeader title="Platform Overview" icon={<Activity className="text-green-700" />} />

      {/* PLATFORM KPI STATS */}
      <div className="grid md:grid-cols-4 gap-6">
        <StatCardGlow
          title="Total Farms"
          value={stats?.farms || 0}
          icon={<Factory className="h-8 w-8 text-green-600" />}
        />
        <StatCardGlow
          title="Total Tenants"
          value={stats?.tenants || 0}
          icon={<Users className="h-8 w-8 text-green-600" />}
        />
        <StatCardGlow
          title="Registered Animals"
          value={stats?.animals || 0}
          icon={<Layers className="h-8 w-8 text-green-600" />}
        />
        <StatCardGlow
          title="Active Funding Rounds"
          value={stats?.fundingRounds || 0}
          icon={<Coins className="h-8 w-8 text-green-600" />}
        />
      </div>

      <div className="grid md:grid-cols-4 gap-6">
        <StatCardGlow
          title="Profit Sharing Cycles"
          value={stats?.profitSharing || 0}
          icon={<Wallet className="h-8 w-8 text-green-600" />}
        />
        <StatCardGlow
          title="Open Market Listings"
          value={stats?.marketListings || 0}
          icon={<ShoppingCart className="h-8 w-8 text-green-600" />}
        />
        <StatCardGlow
          title="Active SACCO Users"
          value={stats?.saccoUsers || 0}
          icon={<LineChart className="h-8 w-8 text-green-600" />}
        />
        <StatCardGlow
          title="Web3 Farms Onboarded"
          value={stats?.web3Farms || 0}
          icon={<Network className="h-8 w-8 text-green-600" />}
        />
      </div>

      {/* ACTIONS */}
      <FarmSectionHeader
        title="Admin Actions"
        icon={<ArrowRightCircle className="text-green-700" />}
      />

      <div className="grid md:grid-cols-3 gap-6">
        <ActionCard title="Manage Farms" link="/admin/farms" icon={<Factory />} />
        <ActionCard title="Manage Tenants" link="/admin/tenants" icon={<Users />} />
        <ActionCard title="Manage Animals" link="/admin/animals" icon={<Layers />} />
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        <ActionCard title="Funding Rounds" link="/admin/funding-rounds" icon={<Coins />} />
        <ActionCard title="Profit Sharing" link="/admin/profit-sharing" icon={<Wallet />} />
        <ActionCard title="Open Market Oversight" link="/admin/market" icon={<ShoppingCart />} />
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        <ActionCard title="SACCO System" link="/admin/sacco" icon={<LineChart />} />
        <ActionCard title="Web3 Farms" link="/admin/web3" icon={<Network />} />
        <ActionCard title="Global Analytics" link="/admin/analytics" icon={<Globe2 />} />
      </div>
    </div>
  );
};
